var map = {
	"./gallery_00.jpg": 2129,
	"./gallery_01.jpg": 2130,
	"./gallery_02.jpg": 2131,
	"./gallery_03.jpg": 2132,
	"./gallery_04.jpg": 2133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2128;